<!-- TEMPLATE -->
<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <div class="card card-chart">
            <div class="card-body text-center">
              <div class="card-title">
                <h3 class="card-title">
                  <i class="tim-icons icon-sound-wave text-success"></i> #
                  Submitted Emails
                </h3>
              </div>
              <p class="card-text display-3">
                {{ totalSubmitted }}
                <br /><br />
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card card-chart">
            <div class="card-body text-center">
              <div class="card-title">
                <h3 class="card-title">
                  <v-icon class="text-success">mdi-flag-outline</v-icon> Flagged
                  Emails
                </h3>
              </div>
              <p class="card-text display-3">
                <span class="text-danger">{{ totalFlagged }}</span> /
                <span class="text-success">{{ totalSubmitted }} </span>
                <br />
                <i class="text-secondary h5">
                  {{ flaggedPerc() }}% phishing emails</i
                >
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card card-chart">
            <div class="card-body text-center">
              <div class="card-title">
                <h3 class="card-title">
                  <v-icon class="text-success">mdi-book-outline</v-icon> Top
                  Rules
                </h3>
              </div>
              <p class="card-text text-left pl-12">
                <span v-for="i in topRules" :key="i">
                  <div class="row row-bottom-margin">
                    <div class="col-lg-3 col-md-3 col-sm-2">
                      <v-chip
                        color="red"
                        class="text-danger"
                        dark
                        small
                        outlined
                      >
                        <strong>{{ i.count }}</strong>
                      </v-chip>
                    </div>
                    <div class="col-lg-9 col-md-9 col-sm-10">
                      {{ i.name }} <br /><br />
                    </div>
                  </div>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";

export default {
  name: "EmailStatistics",
  data() {
    return {
      totalSubmitted: "",
      totalFlagged: "",
      topRules: [],
    };
  },
  mounted() {
    this.fetchData();
  },

  computed: {},

  methods: {
    fetchData() {
      //this.$store.dispatch('refreshEmailStatiEmailstics')
      PhishingApi.getStatisticsEmail()
        .then((response) => {
          this.totalSubmitted = response["total-submitted"];
          this.totalFlagged = response["total-flagged"];
          this.topRules = response["top-rules"];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    flaggedPerc() {
      return Math.round((this.totalFlagged / this.totalSubmitted) * 100);
    },
  },
  filters: {
    print_top(value) {
      if (value.length > 5) {
        return value.slice(0, 5);
      } else {
        return value;
      }
    },
  },

  components: {},
};
</script>

<!-- Style -->
<style>
.card {
  height: 100%;
}
.row-bottom-margin {
  margin-bottom: -20px;
}
</style>